

export const scrollToTop = ({
  elementId,
  target,
}: {
  elementId?: string;
  target?: "window";
}) => {
  if (target === "window") {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  } else if (elementId) {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }
};
